import React from 'react';

export const IconFire = ({
  size = 10,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  return (
    <svg
      className={className}
      width={0.8 * size}
      height={size}
      viewBox="0 0 8 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.00012207 6C0.00012207 5.12044 0.208567 4.31489 0.625455 3.58333C1.0419 2.85178 1.50012 2.21978 2.00012 1.68733C2.50012 1.15489 2.95834 0.740667 3.37479 0.444667L4.00012 0V1.65267C4.00012 1.93044 4.09745 2.16667 4.29212 2.36133C4.48634 2.55556 4.72701 2.65267 5.01412 2.65267C5.17145 2.65267 5.31257 2.62022 5.43745 2.55533C5.56279 2.49089 5.67634 2.39844 5.77812 2.278L6.00012 2C6.58323 2.33333 7.06479 2.87511 7.44479 3.62533C7.82434 4.37511 8.00945 5.162 8.00012 5.986C7.99079 6.70822 7.81723 7.368 7.47945 7.96533C7.14123 8.56267 6.66657 9.04644 6.05545 9.41667C6.2039 9.20378 6.31501 8.97689 6.38879 8.736C6.46301 8.49511 6.50012 8.24978 6.50012 8C6.50012 7.69422 6.44679 7.398 6.34012 7.11133C6.2339 6.82422 6.07434 6.56489 5.86145 6.33333L4.00012 4.25L2.13879 6.33333C1.9259 6.56489 1.76634 6.82422 1.66012 7.11133C1.55345 7.398 1.50012 7.69422 1.50012 8C1.50012 8.25911 1.53946 8.51133 1.61812 8.75667C1.69679 9.00245 1.81479 9.23178 1.97212 9.44467C1.36101 9.08333 0.879677 8.59711 0.528122 7.986C0.176122 7.37489 0.00012207 6.71289 0.00012207 6ZM4.00012 5.75L5.11145 7C5.24079 7.13867 5.3379 7.29378 5.40279 7.46533C5.46768 7.63644 5.50012 7.81467 5.50012 8C5.50012 8.41689 5.35434 8.77111 5.06279 9.06267C4.77123 9.35422 4.41701 9.5 4.00012 9.5C3.58323 9.5 3.22901 9.35422 2.93745 9.06267C2.6459 8.77111 2.50012 8.41689 2.50012 8C2.50012 7.81467 2.53257 7.63644 2.59746 7.46533C2.66234 7.29378 2.75946 7.13867 2.88879 7L4.00012 5.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
